<template>
  <main>
    <section class="user-payment">
      <form @submit.prevent="requestGateway">
        <label>
          <span>
            نام و نام خانوادگی
          </span>
          <input type="text" v-model="fullName" />
        </label>
        <label>
          <span>
            مبلغ (تومان)
          </span>
          <input
            type="text"
            id="price-number"
            @input="seperateValue"
            v-model="amount"
          />
        </label>
        <button
          :disabled="disabled"
          :class="{ disabledBtn: disabled }"
          type="button"
          @click="requestGateway"
        >
          پرداخت
        </button>
      </form>
    </section>
  </main>
</template>

<script>
import { pay } from "@/libraries/functions";

export default {
  data() {
    return {
      fullName: "",
      amount: null,
      disabled: false,
    };
  },
  methods: {
    async requestGateway() {
      if (this.fullName.length == 0) {
        this.$notify({
          group: "error",
          title: "کاربر گرامی",
          text: "لطفا نام و نام خانوادگی خود را وارد کنید",
          type: "error",
          duration: "5000",
        });
      } else if (this.amount == null && this.amount <= 0) {
        this.$notify({
          group: "error",
          title: "کاربر گرامی",
          text: "لطفا مبلغ خود رو  وارد کنید",
          type: "error",
          duration: "5000",
        });
      } else {
        const rawAmountString = this.amount.replace(/,/g, "");
        console.log(rawAmountString, "this.rawAmountString");
        try {
          this.disabled = true;
          let fd = new FormData();
          fd.append("name", this.fullName);
          fd.append("amount", rawAmountString);
          fd.append("payment_driver", "saman"); 

          const response = await this.$axios.post("front/gatewaylink", fd);
          let responseData = response.data.data;
          console.log(responseData, "responseData");
          this.$root.notify(response.data.message, "success");
          if (responseData.need_pay) {
            let makeResponse = responseData.make_response;
            pay(makeResponse);
          } else {
            this.$router.push("/order/" + responseData.order_id);
          }
          this.disabled = true;
        } catch (error) {
          console.error(error);
          this.disabled = false;

          this.$root.notify(error, "error");
        }
      }

      //   const numericAmount = parseInt(rawAmountString);
      //   console.log(numericAmount, "this.numericAmount");
    },
    seperateValue(event) {
      // 1. دریافت مقدار خام از فیلد ورودی
      let inputVal = event.target.value;

      // 2. حذف کاماها (برای رسیدن به عدد خالص)
      let cleanVal = inputVal.replace(/,/g, "");

      // 3. *مهم:* حذف تمام کاراکترهای غیر عددی (فقط ارقام 0-9 را نگه می‌دارد)
      // این بخش تضمین می‌کند که کاربر نتواند حروفی مانند 'الف' یا 'ت' یا سایر نمادها را تایپ کند.
      cleanVal = cleanVal.replace(/\D/g, "");

      // 4. اگر مقدار پاکسازی شده خالی بود، amount را خالی می‌کنیم و برمی‌گردیم
      if (!cleanVal) {
        this.amount = "";
        return;
      }

      // 5. فرمت‌کردن مقدار خالص با جداکننده سه‌رقمی
      const formattedVal = cleanVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 6. به‌روزرسانی مدل Vue
      this.amount = formattedVal;
    },
  },
};
</script>
<style scoped>
.disabledBtn {
  opacity: 0.5;
}
main {
  overflow: hidden;
}
.user-payment {
  width: 100vw;
  height: calc(100vh - 110px);
  display: grid;
  place-items: center;
}
.user-payment form {
  width: 800px;
  box-shadow: 0 0 5px rgba(128, 128, 128, 0.438);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-content: center;
  padding: 2rem;
  background-color: white;
  gap: 1rem;
}
.user-payment form label {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
input {
  border: 1px solid #80808078;
  padding: 6px;
  border-radius: 6px;
}
button {
  padding: 9px 0;
  background-color: #1e7f84;
  color: white;
}
</style>
